// extracted by mini-css-extract-plugin
export default {"timerOuter":"timer_timerOuter__GJnil","timer":"timer_timer__adddA","timerChar":"timer_timerChar__xXER6"};